<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
        <v-card-title class="headline">
          Техническая поддержка
        </v-card-title>
        <v-flex xs12 class="px-2">
          <v-card flat>
            <v-card-text>
              <v-textarea
              label="Ваш вопрос"
              v-model="post"
              outline hide-details
              ></v-textarea>
            </v-card-text>
            <v-card-actions class="mt-0 pt-0">
              <v-spacer></v-spacer>
              <v-btn color="primary" outline class="mb-1 mt-0 mr-2"
              :disabled="validForm === false"
              @click="send"
              >
                Отправить
                <v-icon right>send</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="chat">
          <ChatMessage v-for="msg in chat" :key="msg.chatmessageid" :message="msg" class="my-1 mx-1">
          </ChatMessage>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
import ChatMessage from '@/components/ChatMessage.vue'

export default {
  name: 'Support',
  components: { ChatMessage },
  data: () => ({
    chat: [],
    post: null
  }),
  methods: {
    async fetch () {
      const { chat } = await this.fetchChat()
      if (chat) this.chat = chat.messages
      this.$store.dispatch('sioOn', {
        topic: 'chatmessage',
        cb: (x) => {
          this.chat.unshift(x)
        }
      })
    },
    async fetchChat () {
      return this.$store.dispatch('sioRequest', {
        topic: 'fetch-chat'
      })
    },
    async send () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'chat-post',
          pl: { content: this.post }
        })
        this.$store.dispatch('snack', meta.msg)
        this.post = null
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    validQuestion () {
      if (!this.post) return false
      return this.post.length > 5
    },
    validForm () {
      return this.validQuestion
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
</style>
